import type { IconProps } from './icon.types'

const ArrowLeftIcon = (props: IconProps) => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 18 18'
    fill='none'
    stroke='currentColor'
    strokeWidth='1'
    strokeLinecap='round'
    strokeLinejoin='round'
    aria-hidden='true'
    data-testid='arrow-left-icon'
    {...props}
  >
    <path d='M11 3.5 5.5 9 11 14.5' />
    <path d='M5.5 9h9' />
  </svg>
)

export default ArrowLeftIcon
